import React, { useEffect, useState } from "react";
import './style.scss';
import { RightArrow } from './../../assets';

// Array of months for filtering
const Months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const FilterRefined = ({ Projects, Leads = [], CloseFilterML, CloseCardClck, getFilterTerm, terms, handleFilterChange }) => {
    const displayNames = {
        Month: "Month",
        CategoryOfService: "Category Of Service",
        FulfilmentLead: "Fulfilment Lead",
        ContractType: "Contract Type",
        FulfilmentStage: "Fulfilment Stage",
        JobStatus: "Job Status"
    };

    // State to manage filter options and their properties
    const [FilterObj, setFilterObj] = useState({
        Month: {
            Subs: Months.slice(1), // Months excluding the empty string
            IsActive: false, // Whether the filter dropdown is active
            Top: 7.5, // Positioning for dropdown
        },
        CategoryOfService: {
            Subs: [
                'Design and Illustration',
                'Digital Marketing and Social Media',
                'Film Photography and Videography',
                'Software Development',
                'Writing',
                'PR',
                'Other'
            ].sort(), // Sorted list of services
            IsActive: false,
            Top: 17.5,
        },
        FulfilmentLead: {
            Subs: Leads.map(lead => lead._id).sort((a, b) => {
                const leadA = Leads.find(l => l._id === a);
                const leadB = Leads.find(l => l._id === b);
                return `${leadA.firstName} ${leadA.lastName}`.localeCompare(`${leadB.firstName} ${leadB.lastName}`);
            }),
            IsActive: false,
            Top: 31,
        },
        ContractType: {
            Subs: [
                'Once-Off', 'Fixed-Term Placement', 'Short-Term Placement','Permanent Placement','On-going'
            ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })), // Case-insensitive sorting
            IsActive: false,
            Top: 44,
        },
        FulfilmentStage: {
            Subs: [
                'Quote and Project Plan', 'Deposit Invoice', 'Contracting',
                'Project in Progress', 'Milestone Payment',
                'Professional Evaluation', 'Final Payment', 'Project Closed'
            ].sort(),
            IsActive: false,
            Top: 56.5,
        },
        JobStatus: {
            Subs: [
                'Not Started','Approved', 'In Progress', 'Completed', 'On Hold', 'Cancelled'
            ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })), // Case-insensitive sorting
            IsActive: false,
            Top: 70.5,
        },
    });

    // State to manage selected filter terms
    const [Terms, setTerms] = useState([]);
    // State to manage filtered projects
    const [FilteredProjects, setFilteredProjects] = useState([]);

    // Update terms whenever the `terms` prop changes
    useEffect(() => {
        setTerms(terms);
    }, [terms]);

    // Handle mouse enter event to activate a filter dropdown
    const handleFilterMouseEnter = (e) => {
        const ID = e.currentTarget.id;
        setFilterObj(prev => ({ ...prev, [ID]: { ...prev[ID], IsActive: true } }));
    };

    // Handle mouse leave event to deactivate a filter dropdown
    const handleFilterMouseLeave = (e) => {
        const ID = e.currentTarget.id;
        setFilterObj(prev => ({ ...prev, [ID]: { ...prev[ID], IsActive: false } }));
    };

    // Get the full name of a lead by ID
    const getLeadName = (id) => {
        const lead = Leads.find(item => item._id === id);
        return lead ? `${lead.firstName} ${lead.lastName}` : '';
    };

    // Handle clicking on a filter item
    const handleItemClick = (value, key) => {
        let updatedTerms = [...Terms];
        let searchTerm = value;
        let projectArr = [];

        // Determine the initial project array based on whether terms exist
        if (updatedTerms.length === 0) {
            projectArr = [...Projects];
        } else {
            projectArr = [...FilteredProjects];
        }

        // Special handling for Month filter
        if (key === 'Month') {
            searchTerm = Months.indexOf(value);
            projectArr.filter(project => new Date(project.date).getMonth() + 1 === searchTerm);
        }

        // Add the term if it doesn't already exist
        if (!updatedTerms.includes(searchTerm)) {
            updatedTerms.push(searchTerm);
        }

        // Update state with filtered projects and terms
        setFilteredProjects(projectArr);
        setTerms(updatedTerms);
        getFilterTerm(searchTerm);
    };

    // Remove a selected filter term
    const removeTerm = (term) => {
        const updatedTerms = Terms.filter(t => t !== term);
        setTerms(updatedTerms);
        handleFilterChange(updatedTerms);
    };

    return (
        <div className="filtermaincard" onMouseLeave={CloseFilterML}>
            {Object.entries(FilterObj).map(([key, { Subs, IsActive, Top }]) => (
                <div key={key} className="filteritem" id={key} onMouseEnter={handleFilterMouseEnter} onMouseLeave={handleFilterMouseLeave}>
                    <p className="itemname">
                        {displayNames[key]} <span><img src={RightArrow} /></span>
                    </p>

                    <div className="selectedtermdiv">
                        {Terms.map((term) => {
                            let lead = '';
                            if (typeof term === 'string' && term.match(/^[0-9a-fA-F]{24}$/)) {
                                lead = Leads.find(person => person._id === term);
                                lead = `${lead.firstName} ${lead.lastName}`;
                            }

                            if (key !== 'Month' && Subs.includes(term) && key === 'FulfilmentLead') {
                                return (
                                    <span key={term}>
                                        <span>{lead.slice(0, 5)}{lead.length > 10 && '...'}</span>
                                        <span onClick={() => removeTerm(term)} className="txtspan">X</span>
                                    </span>
                                );
                            }

                            if (key !== 'Month' && Subs.includes(term) && key) {
                                return (
                                    <span key={term}>
                                        <span>{term.slice(0, 5)}{term.length > 10 && '...'}</span>
                                        <span onClick={() => removeTerm(term)} className="txtspan">X</span>
                                    </span>
                                );
                            }

                            if (key === 'Month' && typeof term === 'number') {
                                return (
                                    <span key={term}>
                                        {Months[term].slice(0, 3)}
                                        <span onClick={() => removeTerm(term)} className="txtspan">X</span>
                                    </span>
                                );
                            }
                            return null;
                        })}
                    </div>

                    <hr />

                    {IsActive && (
                        <div className="itemsubs" style={{ top: `${Top}%` }}>
                            {Subs.map((sub) => (
                                <div key={sub} className="filteritem">
                                    <p className="itemname" onClick={() => handleItemClick(sub, key)}>
                                        {key === 'FulfilmentLead' ? getLeadName(sub) : sub}{" "}
                                        <span onClick={() => handleItemClick(sub, key)}><img src={RightArrow} /></span>
                                    </p>
                                    <hr />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}

            <p className="clearfilter" onClick={CloseCardClck}>
                <span>Clear Filters</span>
            </p>
        </div>
    );
};

export default FilterRefined;
